"use client";

import { InfoBox, Link, Typography } from "@cappelendamm/design-system/react";
import { WarningCircle } from "iconoir-react";
import { getIsTeacherFromSessionClaims } from "@/utils/getIsTeacherFromSessionClaims";
import {
  isActiveOrganizationApproved,
  isApprovalStale,
} from "@/organizations/activeOrganization";
import { useAuth } from "@clerk/nextjs";
import { RefreshSchoolApprovalButton } from "@/organizations/school/RefreshSchoolApprovalButton";

export const UnapprovedSchoolInfoBox = () => {
  const { sessionClaims, isLoaded } = useAuth();

  if (!isLoaded) return null;

  const isTeacher = getIsTeacherFromSessionClaims(sessionClaims);
  const isSchoolApproved = isActiveOrganizationApproved(sessionClaims);

  // Only relevant for a signed-in teacher whose organization is not yet
  // approved for purchasing restricted products. Non-teachers already get the
  // RestrictedProductInfoBox, and approved schools can purchase.
  if (!isTeacher || isSchoolApproved) return null;

  // The stored approval belongs to another organization (or predates the
  // org-scoped claim). SyncOrganizationApproval is re-resolving it right now,
  // so stay quiet rather than accusing an approved school of being unapproved.
  if (isApprovalStale(sessionClaims)) return null;

  return (
    <InfoBox className="flex w-full items-start gap-2">
      <WarningCircle width={32} height={32} className="text-lg" />
      <div className="flex flex-col gap-2">
        <Typography variant="body-sm">
          Organisasjonen din er ikke godkjent for å kjøpe dette produktet.
          Godkjenning av skolekunder gjøres manuelt, så hvis skolen nettopp har
          blitt godkjent kan statusen din være utdatert. Trykk på knappen under
          for å hente inn oppdatert skolekundestatus.
        </Typography>
        <RefreshSchoolApprovalButton />
        <Typography variant="body-sm">
          Tror du dette er en feil?{" "}
          <Link
            variant="inline"
            href="mailto:kundeservice@cappelendamm.no"
            className="text-black"
          >
            Kontakt oss for hjelp.
          </Link>
        </Typography>
      </div>
    </InfoBox>
  );
};
